

let pceApi = {
    list(){
        return new Promise((resolve, reject) => {
           
            resolve({
             Code: 0,
             Count: 3,
             Data: [
             {
               DemandDate: '2022-1-1',
               DemandOrderNumber: 1,
               Team: '部门1',
               Buyer: '请购人1',
               StockName: '存货1',
               SuppliersCode: '0001',
               Suppliers: '供应商1',
               ChargePersonnel: '分管人员1',
               stocks: '存货1',
               Model: '规模1',
               MasterUnit: '主单位1',
               Color: '颜色1',
               Quantity: 500,
               Amount: 1000,
               OrderNumber: '0001',
               CumulativeQuantity: 5000,
               NotQuantity: 100,
               BeenAmount: 200,
               NotAmount: 300,

             },
             {
                DemandDate: '2022-1-1',
                DemandOrderNumber: 1,
                Team: '部门1',
                Buyer: '请购人1',
                StockName: '存货1',
                SuppliersCode: '0001',
                Suppliers: '供应商1',
                ChargePersonnel: '分管人员1',
                stocks: '存货1',
                Model: '规模1',
                MasterUnit: '主单位1',
                Color: '颜色1',
                Quantity: 500,
                Amount: 1000,
                OrderNumber: '0001',
                CumulativeQuantity: 5000,
                NotQuantity: 100,
                BeenAmount: 200,
                NotAmount: 300,
 
              },
              {
                DemandDate: '2022-1-1',
                DemandOrderNumber: 1,
                Team: '部门1',
                Buyer: '请购人1',
                StockName: '存货1',
                SuppliersCode: '0001',
                Suppliers: '供应商1',
                ChargePersonnel: '分管人员1',
                stocks: '存货1',
                Model: '规模1',
                MasterUnit: '主单位1',
                Color: '颜色1',
                Quantity: 500,
                Amount: 1000,
                OrderNumber: '0001',
                CumulativeQuantity: 5000,
                NotQuantity: 100,
                BeenAmount: 200,
                NotAmount: 300,
 
              },
           ]
           })
       })
    }
}

let pcsApi = {
    list(){
        return new Promise((resolve, reject) => {
           
            resolve({
             Code: 0,
             Count: 3,
             Data: [
             {
               InventoryCode: '0001',
               InventoryName: '存货名字',
               Model: '规模1',
               Quantity: 1000,
               Amount: 1000,
               CumulativeQuantity: 200,
             },
             {
                InventoryCode: '0001',
                InventoryName: '存货名字',
                Model: '规模1',
                Quantity: 1000,
                Amount: 1000,
                CumulativeQuantity: 200,
 
              },
              {
                InventoryCode: '0001',
                InventoryName: '存货名字',
                Model: '规模1',
                Quantity: 1000,
                Amount: 1000,
                CumulativeQuantity: 200,
 
              },
           ]
           })
       })
    }
}

let pcdApi = {
    list(){
        return new Promise((resolve, reject) => {
           
            resolve({
             Code: 0,
             Count: 3,
             Data: [
             {
               DocTime: '2022-7-1',
               DocCode: '0001',
               team: '部门1',
               HandlePerson: '经手人1',
               OrderStatus: 1,
               InventoryCode: '111',
               InventoryName: '存货1',
               Model: '规模1',
               Color: '颜色',
               Suppliers: '供应商',
               PurchasingUnit: '单位',
               Quantity: 500,
               Amount: 3000,
               DemandTime: '2022-02-2',
               CumulativeQuantity: 4000,
               SourceOrder: '020',
               SourceOrderNumber: '2022',
             },
             {
                DocTime: '2022-7-1',
                DocCode: '0001',
                team: '部门1',
                HandlePerson: '经手人1',
                OrderStatus: 1,
                InventoryCode: '111',
                InventoryName: '存货1',
                Model: '规模1',
                Color: '颜色',
                Suppliers: '供应商',
                PurchasingUnit: '单位',
                Quantity: 500,
                Amount: 3000,
                DemandTime: '2022-02-2',
                CumulativeQuantity: 4000,
                SourceOrder: '020',
                SourceOrderNumber: '2022',
 
              },
              {
                DocTime: '2022-7-1',
                DocCode: '0001',
               team: '部门1',
               HandlePerson: '经手人1',
               OrderStatus: 1,
               InventoryCode: '111',
               InventoryName: '存货1',
               Model: '规模1',
               Color: '颜色',
               Suppliers: '供应商',
               PurchasingUnit: '单位',
               Quantity: 500,
               Amount: 3000,
               DemandTime: '2022-02-2',
               CumulativeQuantity: 4000,
               SourceOrder: '020',
               SourceOrderNumber: '2022',
 
              },
           ]
           })
       })
    }
}

let ptdApi = {
  list(){
      return new Promise((resolve, reject) => {
         
          resolve({
           Code: 0,
           Count: 3,
           Data: [
           {
             a: '2022-2-2',
             b: '222',
             c: '生产车间',
             d: '负责人1',
             e: '342',
             f: '454',
             g: '421',
             h: '1254',
             i: '1542',
             j: '121',
             k: '1245',
             l: 454,
             m: '2022-6-5',
             n: '2022-8-6',

           },
           {
              a: '2022-2-2',
              b: '222',
              c: '生产车间',
              d: '负责人1',
              e: '342',
              f: '454',
              g: '421',
              h: '1254',
              i: '1542',
              j: '121',
              k: '1245',
              l: 454,
              m: '2022-6-5',
              n: '2022-8-6',

            },
            {
              a: '2022-2-2',
              b: '222',
              c: '生产车间',
              d: '负责人1',
              e: '342',
              f: '454',
              g: '421',
              h: '1254',
              i: '1542',
              j: '121',
              k: '1245',
              l: 454,
              m: '2022-6-5',
              n: '2022-8-6',

            },
         ]
         })
     })
  }
}

let ptsApi = {
  list(){
      return new Promise((resolve, reject) => {
         
          resolve({
           Code: 0,
           Count: 3,
           Data: [
           {
             a: '0002',
             b: '存货1',
             c: '规模',
             d: '蓝色',
             e: '单位',
             f: 8,
             g:  10,

           },
           {
            a: '0002',
            b: '存货1',
            c: '规模',
            d: '蓝色',
            e: '单位',
            f: 8,
            g:  10,

            },
            {
              a: '0002',
              b: '存货1',
              c: '规模',
              d: '蓝色',
              e: '单位',
              f: 8,
              g:  10,

            },
         ]
         })
     })
  }
}

let ptpApi = {
  list(){
      return new Promise((resolve, reject) => {
         
          resolve({
           Code: 0,
           Count: 3,
           Data: [
           {
             a: '2022-02-03',
             b: '0222',
             c: '存货001',
             d: '存货名称',
             e: '主单位',
             f: '颜色',
             g:  '属性',
             h: 200,
             i: 100,
             j: 50,
             k: 20,

           },
           {
            a: '2022-02-03',
            b: '0222',
            c: '存货001',
            d: '存货名称',
            e: '主单位',
            f: '颜色',
            g:  '属性',
            h: 200,
            i: 100,
            j: 50,
            k: 20,

            },
            {
              a: '2022-02-03',
              b: '0222',
              c: '存货001',
              d: '存货名称',
              e: '主单位',
              f: '颜色',
              g:  '属性',
              h: 200,
              i: 100,
              j: 50,
              k: 20,

            },
         ]
         })
     })
  }
}

let ptmdApi = {
  list(){
      return new Promise((resolve, reject) => {
         
          resolve({
           Code: 0,
           Count: 3,
           Data: [
           {
             a: '2022-02-03',
             b: '0222',
             c: '存货001',
             d: '存货名称',
             e: '规格型号',
             f: '属性',
             g:  '颜色',
             h: '材料编码',
             i: '材料名称',
             j: '材料规格',
             k: '属性(材料)',
             l: '颜色(材料)',
             m: '预出仓库',
             n: '计量单位',
             o: 51,
             p: 30,
             q: 40,


           },
           {
            a: '2022-02-03',
             b: '0222',
             c: '存货001',
             d: '存货名称',
             e: '规格型号',
             f: '属性',
             g:  '颜色',
             h: '材料编码',
             i: '材料名称',
             j: '材料规格',
             k: '属性(材料)',
             l: '颜色(材料)',
             m: '预出仓库',
             n: '计量单位',
             o: 51,
             p: 30,
             q: 40,
            },
            {
              a: '2022-02-03',
             b: '0222',
             c: '存货001',
             d: '存货名称',
             e: '规格型号',
             f: '属性',
             g:  '颜色',
             h: '材料编码',
             i: '材料名称',
             j: '材料规格',
             k: '属性(材料)',
             l: '颜色(材料)',
             m: '预出仓库',
             n: '计量单位',
             o: 51,
             p: 30,
             q: 40,
            },
         ]
         })
     })
  }
}

let ptmsApi = {
  list(){
      return new Promise((resolve, reject) => {
         
          resolve({
           Code: 0,
           Count: 3,
           Data: [
           {
             a: '存货编码',
             b: '存货名称',
             c: '规格型号',
             d: '材料编码',
             e: '材料名称',
             f: '材料规格',
             g:  '主单位',
             h: 51,
             i: 30,
             j: 40,
            


           },
           {
            a: '存货编码',
            b: '存货名称',
            c: '规格型号',
            d: '材料编码',
            e: '材料名称',
            f: '材料规格',
            g:  '主单位',
            h: 51,
            i: 30,
            j: 40,
            },
            {
              a: '存货编码',
             b: '存货名称',
             c: '规格型号',
             d: '材料编码',
             e: '材料名称',
             f: '材料规格',
             g:  '主单位',
             h: 51,
             i: 30,
             j: 40,
            },
         ]
         })
     })
  }
}

let ptmeApi = {
  list(){
      return new Promise((resolve, reject) => {
         
          resolve({
           Code: 0,
           Count: 3,
           Data: [
           {
             a: '工单号',
             b: '材料名称',
             c: 12,
             d: 50,
             e: 80,
             f: 10,
             g: "完工状态",
            


           },
           {
              a: '工单号',
             b: '材料名称',
             c: 12,
             d: 50,
             e: 80,
             f: 10,
             g: "完工状态",
            },
            {
              a: '工单号',
              b: '材料名称',
              c: 12,
              d: 50,
              e: 80,
              f: 10,
              g: "完工状态",
            },
         ]
         })
     })
  }
}

let pcpApi = {
  list(){
      return new Promise((resolve, reject) => {
         
          resolve({
           Code: 0,
           Count: 3,
           Data: [
           {
              SerialNumber: '01',
              Code: '产品编号',
              Name: '产品名称',
              Model: '规格',
              Color: '颜色',
              MachiningProcess: '加工流程',
              Bom: "111",
           },
           {
              SerialNumber: '01',
              Code: '产品编号',
              Name: '产品名称',
              Model: '规格',
              Color: '颜色',
              MachiningProcess: '加工流程',
              Bom: "222",
            },
            {
              SerialNumber: '01',
              Code: '产品编号',
              Name: '产品名称',
              Model: '规格',
              Color: '颜色',
              MachiningProcess: '加工流程',
              Bom: "333",
            },
         ]
         })
     })
  }
}

let pcaApi = {
  list(){
    console.log('触发list')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
            Code: '01',
            Name: '工序1',
            ProductionPhase: '注塑',
            SerialNumber: 1,
         },
         {
            Code: '02',
            Name: '工序2',
            ProductionPhase: '注塑',
            SerialNumber: 2,
          },
          {
            Code: '03',
            Name: '工序1',
            ProductionPhase: '注塑',
            SerialNumber: 3,
          },
       ]
       })
   })
  },
  save(data){
    console.log(data);
    return new Promise((resolve, reject) => {
       
      resolve({
       Code: 0,
       Mes: '保存成功',
     })
  })
  },
  del(data){
    console.log(data);
    return new Promise((resolve, reject) => {
       
      resolve({
       Code: 0,
       Mes: '删除成功',
     })
  })
  }
}

let pcp1Api = {
  list(){
    console.log('触发list')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
          {
             Order: '销售订单号',
             SubOrder: '布产单号',
             DocTime: '2022-2-10',
             InventoryCode: '663',
             InventoryName: '存货名称',
             orderProgress: '50%',
          },
          {
             Order: '销售订单号',
             SubOrder: '布产单号',
             DocTime: '2022-2-10',
             InventoryCode: '663',
             InventoryName: '存货名称',
             orderProgress: '50%',
           },
           {
             Order: '销售订单号',
             SubOrder: '布产单号',
             DocTime: '2022-2-10',
             InventoryCode: '663',
             InventoryName: '存货名称',
             orderProgress: '50%',
           },
        ]
       })
   })
  },
  info(data){
    console.log(data);
    return new Promise((resolve, reject) => {
       
      resolve({
       Code: 0,
       Count: 3,
       Data: [
        {
           SubOrder: '布产单号',
           DocTime: '2022-2-10',
           InventoryCode: '663',
           InventoryName: '存货名称',
           zhusu: '50%',
           jiagong: '50%',
        },
        {
           Order: '销售订单号',
           SubOrder: '布产单号',
           DocTime: '2022-2-10',
           InventoryCode: '663',
           InventoryName: '存货名称',
           zhusu: '50%',
           jiagong: '50%',
         },
         {
           Order: '销售订单号',
           SubOrder: '布产单号',
           DocTime: '2022-2-10',
           InventoryCode: '663',
           InventoryName: '存货名称',
           zhusu: '50%',
           jiagong: '50%',
         },
      ]
       
     })
    })
  },
  
}

function MOuldList(){
  return new Promise((resolve, reject) => {
       
    resolve({
     Code: 0,
     Count: 3,
     Data: [
      {
        MouldNo: 1,
        MouldName: '模具1',
      },
      {
        MouldNo: 2,
        MouldName: '模具2',
       },
       {
        MouldNo: 3,
        MouldName: '模具3',
       },
    ]
   })
})
}

function getProcess(){
  return new Promise((resolve, reject) => {
       
    resolve({
     Code: 0,
     Count: 3,
     Data: [
      {
        ProcessNo: 1,
        ProcessName: '工序1',
      },
      {
        ProcessNo: 2,
        ProcessName: '工序2',
       },
       {
        ProcessNo: 3,
        ProcessName: '工序3',
       },
    ]
   })
})
}


let mouldListApi = {
  list(){
    console.log('触发list')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
          {
            SolutionsName: '方案3',
            SerialNumber: 1,
            SchedulingType: '部门',
            Moulds: [
              {
                MouldNo: 1,
                MouldName: '模具1',
              },
              {
                MouldNo: 2,
                MouldName: '模具2',
              },
              {
                MouldNo: 3,
                MouldName: '模具3',
              }
            ],
            Process: [
              {
                ProcessNo: 1,
                ProcessName: '工序1',
              },
              {
                ProcessNo: 2,
                ProcessName: '工序2',
              },
              {
                ProcessNo: 3,
                ProcessName: '工序3',
              }
            ]
          },
          {
            SolutionsName: '方案3',
            SerialNumber: 1,
            SchedulingType: '部门',
            Moulds: [
              {
                MouldNo: 1,
                MouldName: '模具1',
              },
              {
                MouldNo: 2,
                MouldName: '模具2',
              },
              {
                MouldNo: 3,
                MouldName: '模具3',
              }
            ],
            Process: [
              {
                ProcessNo: 1,
                ProcessName: '工序1',
              },
              {
                ProcessNo: 2,
                ProcessName: '工序2',
              },
              {
                ProcessNo: 3,
                ProcessName: '工序3',
              }
            ]
          },
          {
            SolutionsName: '方案3',
            SerialNumber: 1,
            SchedulingType: '部门',
            Moulds: [
              {
                MouldNo: 1,
                MouldName: '模具1',
              },
              {
                MouldNo: 2,
                MouldName: '模具2',
              },
              {
                MouldNo: 3,
                MouldName: '模具3',
              }
            ],
            Process: [
              {
                ProcessNo: 1,
                ProcessName: '工序1',
              },
              {
                ProcessNo: 2,
                ProcessName: '工序2',
              },
              {
                ProcessNo: 3,
                ProcessName: '工序3',
              }
            ]
          },
         
        ]
       })
   })
  },
  info(){
    console.log('触发info')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: {
          SolutionsName: '方案3',
          SerialNumber: 1,
          SchedulingType: '部门',
          Moulds: [
            {
              MouldNo: 1,
              MouldName: '模具1',
            },
            {
              MouldNo: 2,
              MouldName: '模具2',
            },
            {
              MouldNo: 3,
              MouldName: '模具3',
            }
          ],
          Process: [
            {
              ProcessNo: 1,
              ProcessName: '工序1',
            },
            {
              ProcessNo: 2,
              ProcessName: '工序2',
            },
            {
              ProcessNo: 3,
              ProcessName: '工序3',
            }
          ]
         }
       })
   })
  },
  save(data){
    console.log('触发save', data);
    return new Promise((resolve, reject) => {
       
      resolve({
       Code: 0,
       Msg: '保存成功'
       })
  })
  },
  del(data){
    console.log('触发del', data);
    return new Promise((resolve, reject) => {
       
      resolve({
       Code: 0,
       Msg: '删除成功'
       })
    })
  }
}

function fittingList(){
  return new Promise((resolve, reject) => {
       
    resolve({
     Code: 0,
     Count: 3,
     Data: [
      {
        FittingNo: 1,
        Fittingame: '配件1',
      },
      {
        FittingNo: 2,
        Fittingame: '配件2',
       },
       {
        FittingNo: 3,
        Fittingame: '配件3',
       },
    ]
   })
})
}

let fittingListApi = {
  list(){
    console.log('触发list  fittingListApi')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
          {
            SolutionsName: '方案3',
            SerialNumber: 1,
            SchedulingType: '部门',
            Fittings: [
              {
                FittingNo: 1,
                FittingName: '配件1',
              },
              {
                FittingNo: 2,
                FittingName: '配件2',
              },
              {
                FittingNo: 3,
                FittingName: '配件3',
              }
            ],
            Process: [
              {
                ProcessNo: 1,
                ProcessName: '工序1',
              },
              {
                ProcessNo: 2,
                ProcessName: '工序2',
              },
              {
                ProcessNo: 3,
                ProcessName: '工序3',
              }
            ]
           },
           {
            SolutionsName: '方案3',
            SerialNumber: 1,
            SchedulingType: '部门',
            Fittings: [
              {
                FittingNo: 1,
                FittingName: '配件1',
              },
              {
                FittingNo: 3,
                FittingName: '配件3',
              }
            ],
            Process: [
              {
                ProcessNo: 1,
                ProcessName: '工序1',
              },
              {
                ProcessNo: 2,
                ProcessName: '工序2',
              },
              {
                ProcessNo: 3,
                ProcessName: '工序3',
              }
            ]
           },
           {
            SolutionsName: '方案3',
            SerialNumber: 1,
            SchedulingType: '部门',
            Fittings: [
              {
                FittingNo: 1,
                FittingName: '配件1',
              },
              {
                FittingNo: 2,
                FittingName: '配件2',
              },
              {
                FittingNo: 3,
                FittingName: '配件3',
              }
            ],
            Process: [
              {
                ProcessNo: 1,
                ProcessName: '工序1',
              },
              {
                ProcessNo: 2,
                ProcessName: '工序2',
              },
              {
                ProcessNo: 3,
                ProcessName: '工序3',
              }
            ]
           },
          
        ]
       })
   })
  },
  info(){
    console.log('触发info fittingListApi')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: {
          SolutionsName: '方案3',
          SerialNumber: 1,
          SchedulingType: '部门',
          Fittings: [
            {
              FittingNo: 1,
              FittingName: '配件1',
            },
            {
              FittingNo: 2,
              FittingName: '配件2',
            },
            {
              FittingNo: 3,
              FittingName: '配件3',
            }
          ],
          Process: [
            {
              ProcessNo: 1,
              ProcessName: '工序1',
            },
            {
              ProcessNo: 2,
              ProcessName: '工序2',
            },
            {
              ProcessNo: 3,
              ProcessName: '工序3',
            }
          ]
         }
       })
   })
  },
  save(data){
    console.log('触发save', data);
    return new Promise((resolve, reject) => {
       
      resolve({
       Code: 0,
       Msg: '保存成功'
       })
  })
  },
  del(data){
    console.log('触发del', data);
    return new Promise((resolve, reject) => {
       
      resolve({
       Code: 0,
       Msg: '删除成功'
       })
    })
  }
  
}


function puList(){
  return new Promise((resolve, reject) => {
       
    resolve({
     Code: 0,
     Count: 3,
     Data: [
      {
        PuNo: 1,
        PuName: '产品1',
      },
      {
        PuNo: 2,
        PuName: '产品2',
       },
       {
        PuNo: 3,
        PuName: '产品3',
       },
    ]
   })
})
}
let puListApi = {
  list(){
    console.log('触发list  fittingListApi')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
          {
            SolutionsName: '方案3',
            SerialNumber: 1,
            SchedulingType: '部门',
            Pus: [
              {
                PuNo: 1,
                PuName: '产品1',
              },
              {
                PuNo: 2,
                PuName: '产品2',
              },
              {
                PuNo: 3,
                PuName: '产品3',
              }
            ],
            Process: [
              {
                ProcessNo: 1,
                ProcessName: '工序1',
              },
              {
                ProcessNo: 2,
                ProcessName: '工序2',
              },
              {
                ProcessNo: 3,
                ProcessName: '工序3',
              }
            ]
           },
           {
            SolutionsName: '方案3',
            SerialNumber: 1,
            SchedulingType: '部门',
            Pus: [
              {
                PuNo: 1,
                PuName: '产品1',
              },
              {
                PuNo: 2,
                PuName: '产品2',
              },
              {
                PuNo: 3,
                PuName: '产品3',
              }
            ],
            Process: [
              {
                ProcessNo: 1,
                ProcessName: '工序1',
              },
              {
                ProcessNo: 2,
                ProcessName: '工序2',
              },
              {
                ProcessNo: 3,
                ProcessName: '工序3',
              }
            ]
           },
           {
            SolutionsName: '方案3',
            SerialNumber: 1,
            SchedulingType: '部门',
            Pus: [
              {
                PuNo: 1,
                PuName: '产品1',
              },
              {
                PuNo: 2,
                PuName: '产品2',
              },
              {
                PuNo: 3,
                PuName: '产品3',
              }
            ],
            Process: [
              {
                ProcessNo: 1,
                ProcessName: '工序1',
              },
              {
                ProcessNo: 2,
                ProcessName: '工序2',
              },
              {
                ProcessNo: 3,
                ProcessName: '工序3',
              }
            ]
           }
        ]
       })
   })
  },
  info(){
    console.log('触发info fittingListApi')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: {
          SolutionsName: '方案3',
          SerialNumber: 1,
          SchedulingType: '部门',
          Pus: [
            {
              PuNo: 1,
              PuName: '产品1',
            },
            {
              PuNo: 2,
              PuName: '产品2',
            },
            {
              PuNo: 3,
              PuName: '产品3',
            }
          ],
          Process: [
            {
              ProcessNo: 1,
              ProcessName: '工序1',
            },
            {
              ProcessNo: 2,
              ProcessName: '工序2',
            },
            {
              ProcessNo: 3,
              ProcessName: '工序3',
            }
          ]
         }
       })
   })
  },
  save(data){
    console.log('触发save', data);
    return new Promise((resolve, reject) => {
       
      resolve({
       Code: 0,
       Msg: '保存成功'
       })
    })
  },
  del(data){
    console.log('触发del', data);
    return new Promise((resolve, reject) => {
       
      resolve({
       Code: 0,
       Msg: '删除成功'
       })
    })
  }
}

let historicalclothApi = {
  list(){
    console.log('触发list  ')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
          {
            Order: '001',
            SubOrder: '001',
            DocTime: '2022-02-21',
            CustomerName: '客户名称',

            Team: '部门',
            Salesman: '业务员',
            InventoryCode: '存货编码',
            InventoryName: '存货名称',

            Bom: 'bom',
            Color: '蓝色',
            Unit: 'pcs',
            Quantity: 222,
            Status: 0,
          },
          {
            Order: '001',
            SubOrder: '001',
            DocTime: '2022-02-21',
            CustomerName: '客户名称',

            Team: '部门',
            Salesman: '业务员',
            InventoryCode: '存货编码',
            InventoryName: '存货名称',

            Bom: 'bom',
            Color: '蓝色',
            Unit: 'pcs',
            Quantity: 222,
            Status: 0,

           },
           {
            Order: '001',
            SubOrder: '001',
            DocTime: '2022-02-21',
            CustomerName: '客户名称',

            Team: '部门',
            Salesman: '业务员',
            InventoryCode: '存货编码',
            InventoryName: '存货名称',

            Bom: 'bom',
            Color: '蓝色',
            Unit: 'pcs',
            Quantity: 222,
            Status: 1,
           },
        ]
       })
   })
  },
  info(){
    console.log('触发info  historicalclothApi')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Data: {
          Order: '001',
          SubOrder: '001',
          DocTime: '2022-02-21',
          CustomerName: '客户名称',

          Team: '部门',
          Salesman: '业务员',
          InventoryCode: '存货编码',
          InventoryName: '存货名称',

          BomVesion: '1.0.0',
          Color: '蓝色',
          Unit: 'pcs',
          OrderQuantity: 225,
          StocksQuantity: 222,
          scQuantity: 3,
          scTeam: '生产部门',
          

          jiaojianList: [
            {
              a: 'x220',
              b: '胶件名称',
              c: '颜色',
              d: '净重',
              e: '模具编号',
              f: '需求数量',
              g: '图片',
              h: '备注',
              i: '库存数量',
              j: '生产数量',
              k: '累计入库数',
              l: '未入库数',
            },
            {
              a: 'x220',
              b: '胶件名称',
              c: '颜色',
              d: '净重',
              e: '模具编号',
              f: '需求数量',
              g: '图片',
              h: '备注',
              i: '库存数量',
              j: '生产数量',
              k: '累计入库数',
              l: '未入库数',
            },
            {
              a: 'x220',
              b: '胶件名称',
              c: '颜色',
              d: '净重',
              e: '模具编号',
              f: '需求数量',
              g: '图片',
              h: '备注',
              i: '库存数量',
              j: '生产数量',
              k: '累计入库数',
              l: '未入库数',
            }
          ],
          mojulist: [
            {
              a: '布产单号',
              b: '工单号',
              c: '模号',
              d: '模具名称',
              e: '颜色',
              f: '每模毛重',
              g: '每模净重',
              h: '1出几套',
              i: '需求模数',
              j: '需求重量',
              k: '图片',
              l: '备注',
              m: '库存数量',
              n: '生产数量',
              o: '累计入库数',
              p: '未入库数',
              q: '排产类型',
              r: '加工部门',
              s: '生产类型',
              t: '加工商',
              v: '单据日期',
              w: '预计完工日期',
              x: '工单备注',
              z: 'BOM版本号',

            },
            {
              a: '布产单号',
              b: '工单号',
              c: '模号',
              d: '模具名称',
              e: '颜色',
              f: '每模毛重',
              g: '每模净重',
              h: '1出几套',
              i: '需求模数',
              j: '需求重量',
              k: '图片',
              l: '备注',
              m: '库存数量',
              n: '生产数量',
              o: '累计入库数',
              p: '未入库数',
              q: '排产类型',
              r: '加工部门',
              s: '生产类型',
              t: '加工商',
              v: '单据日期',
              w: '预计完工日期',
              x: '工单备注',
              z: 'BOM版本号',

            }
          ]
         }
       })
   })
  },
}

let pcd1Api = {
  list(){
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
            DocTime: '2022-2-2',
            DocCode: '001',
         },
         {
            DocTime: '2022-2-2',
            DocCode: '001',
          },
          {
            DocTime: '2022-2-2',
            DocCode: '001',
          },
       ]
       })
   })
  }
}

let jiagongdanApi = {
  list(){
    console.log('jiagongdanApi  list')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
            DocTime: '2022-2-2',
            DocCode: '001',
            weiwaisahng: "委外商",
            InventoryName: '存货名称',
            qua: 500
         },
         {
            DocTime: '2022-2-2',
            DocCode: '001',
            weiwaisahng: "委外商",
            InventoryName: '存货名称',
            qua: 400
          },
          {
            DocTime: '2022-2-2',
            DocCode: '001',
            weiwaisahng: "委外商",
            InventoryName: '存货名称',
            qua: 300
          },
       ]
       })
   })
  }
}

let pcddApi = {
  list(data){
    console.log('pcddApi  list')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          suppliers: [
            {
              suppliersId: '1',
              suppliersName: '供应商名字'
            },
            {
              suppliersId: '2',
              suppliersName: '供应商2'
            }
         
          ],
          InventoryCode: '存货编码',
            InventoryName: '存货名称',
            Model: "规格",
            DocChengchan: '2111',
            qua: 500
         },
         {
          suppliers: [
            {
              suppliersId: '1',
              suppliersName: '供应商名字'
            },
            {
              suppliersId: '2',
              suppliersName: '供应商2'
            }
          ],
          InventoryCode: '存货编码',
            InventoryName: '存货名称',
            Model: "规格",
            DocChengchan: '2111',
            qua: 500
          },
          
          {
            suppliers: [],
            InventoryCode: '存货编码',
            InventoryName: '存货名称',
            Model: "规格",
            DocChengchan: '2111',
            qua: 500
          },
       ]
       })
   })
  },
  info(id){
    console.log('pcddApi  info', id)
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          suppliers: [
            {
              suppliersId: '1',
              suppliersName: '供应商名字'
            },
            {
              suppliersId: '2',
              suppliersName: '供应商2'
            }
         
          ],
          InventoryCode: '存货编码',
            InventoryName: '存货名称',
            Model: "规格",
            DocChengchan: '2111',
            qua: 500
         },
         {
          suppliers: [
            {
              suppliersId: '1',
              suppliersName: '供应商名字'
            },
            {
              suppliersId: '2',
              suppliersName: '供应商2'
            }
          ],
          InventoryCode: '存货编码',
            InventoryName: '存货名称',
            Model: "规格",
            DocChengchan: '2111',
            qua: 500
          },
          
          {
            suppliers: [],
            InventoryCode: '存货编码',
            InventoryName: '存货名称',
            Model: "规格",
            DocChengchan: '2111',
            qua: 500
          },
       ]
       })
   })
  }
}

let clothDialogApi = {
  list(data){
    console.log('clothDialogApi  list')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          InventoryCode: '存货编码',
          InventoryName: '存货名称',
          Model: "规格",
          Unit: '单位',
          Color: '红色',
          Img: '图片',
          Stage: '加工阶段',
          InventoryType: '存货类型',
          kucunQua: 500,
          linyongQua: 400,
          haoyongQua: 300,

         },
         {
          InventoryCode: '存货编码',
          InventoryName: '存货名称',
          Model: "规格",
          Unit: '单位',
          Color: '红色',
          Img: '图片',
          Stage: '加工阶段',
          InventoryType: '存货类型',
          kucunQua: 500,
          linyongQua: 400,
          haoyongQua: 300,
          },
          
          {
            InventoryCode: '存货编码',
            InventoryName: '存货名称',
            Model: "规格",
            Unit: '单位',
            Color: '红色',
            Img: '图片',
            Stage: '加工阶段',
            InventoryType: '存货类型',
            kucunQua: 500,
            linyongQua: 400,
            haoyongQua: 300,
          },
       ]
       })
   })
  },
}

let clothDialog1Api = {
  list(data){
    console.log('clothDialogApi  list')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          InventoryCode: '子件编码',
          InventoryName: '子件名称',
          Model: "规格",
          Unit: '单位',
          xuqiuQua: 400,
          Img: '图片',
          Remark: '备注',
          InventoryType: '存货类型',
          kucunQua: 500,
          linyongQua: 400,
          haoyongQua: 400,


         },
         {
          InventoryCode: '子件编码',
          InventoryName: '子件名称',
          Model: "规格",
          Unit: '单位',
          xuqiuQua: 400,
          Img: '图片',
          Remark: '备注',
          InventoryType: '存货类型',
          kucunQua: 500,
          linyongQua: 400,
          haoyongQua: 400,
          },
          
          {
            InventoryCode: '子件编码',
            InventoryName: '子件名称',
            Model: "规格",
            Unit: '单位',
            xuqiuQua: 400,
            Img: '图片',
            Remark: '备注',
            InventoryType: '存货类型',
            kucunQua: 500,
            linyongQua: 400,
            haoyongQua: 400,
          },
       ]
       })
   })
  },
}

let clothDialog12Api = {
  list(data){
    console.log('clothDialogApi  list')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          InventoryCode: '子件编码',
          InventoryName: '子件名称',
          Model: "规格",
          Unit: '单位',
          Attr: '属性',
          Color: '红色',
          quxiuQua: 100,
          Img: '图片',
          Stage: '加工阶段',
          InventoryType: '存货类型',
          kucunQua: 500,
          linyongQua: 400,
          haoyongQua: 300,

         },
         {
            InventoryCode: '子件编码',
            InventoryName: '子件名称',
            Model: "规格",
            Unit: '单位',
            Attr: '属性',
            Color: '红色',
            quxiuQua: 100,
            Img: '图片',
            Stage: '加工阶段',
            InventoryType: '存货类型',
            kucunQua: 500,
            linyongQua: 400,
            haoyongQua: 300,
          },
          
          {
            InventoryCode: '子件编码',
            InventoryName: '子件名称',
            Model: "规格",
            Unit: '单位',
            Attr: '属性',
            Color: '红色',
            quxiuQua: 100,
            Img: '图片',
            Stage: '加工阶段',
            InventoryType: '存货类型',
            kucunQua: 500,
            linyongQua: 400,
            haoyongQua: 300,
          },
       ]
       })
   })
  },
}

let clothDialog3Api = {
  list(data){
    console.log('clothDialogApi  list')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          InventoryCode: '子件编码',
          InventoryName: '子件名称',
          Model: "规格",
          Unit: '单位',
          Color: '红色',
          quxiuQua: 100,
          Img: '图片',
          Stage: '加工阶段',
          InventoryType: '存货类型',
          kucunQua: 500,
          linyongQua: 400,
          haoyongQua: 300,

         },
         {
          InventoryCode: '子件编码',
          InventoryName: '子件名称',
          Model: "规格",
          Unit: '单位',
          Color: '红色',
          quxiuQua: 100,
          Img: '图片',
          Stage: '加工阶段',
          InventoryType: '存货类型',
          kucunQua: 500,
          linyongQua: 400,
          haoyongQua: 300,
          },
          
          {
            InventoryCode: '子件编码',
            InventoryName: '子件名称',
            Model: "规格",
            Unit: '单位',
            Color: '红色',
            quxiuQua: 100,
            Img: '图片',
            Stage: '加工阶段',
            InventoryType: '存货类型',
            kucunQua: 500,
            linyongQua: 400,
            haoyongQua: 300,
          },
       ]
       })
   })
  },
}

let mergeApi = {
  list(data){
    console.log('mergeApi list')
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          a: '111',
          b: '222',
          c: "33",
          d: '444',
          e: '55',
          f: '666',
          g: '777',
          h: '88',
         },
         {
          a: '111',
          b: '222',
          c: "33",
          d: '444',
          e: '55',
          f: '666',
          g: '777',
          h: '88',
          },
          
          {
            a: '111',
            b: '222',
            c: "33",
            d: '444',
            e: '55',
            f: '666',
            g: '777',
            h: '88',
          },
       ]
       })
   })
  },
}

let mergeDialogApi = {
  list(data){
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          a: '111',
          b: '222',
          c: "33",
          d: '444',
          e: '55',
          f: '666',
          g: '777',
          h: '88',
          i: '999',
          child: [
            {
              a: '1',
              b: '2',
              c: '3',
              d: '4',
              e: '5',
            },
            {
              a: '1',
              b: '2',
              c: '3',
              d: '4',
              e: '5',
            }
          ]
         },
         {
          a: '111',
          b: '222',
          c: "33",
          d: '444',
          e: '55',
          f: '666',
          g: '777',
          h: '88',
          i: '999',
          child: [
            {
              a: '1',
              b: '2',
              c: '3',
              d: '4',
              e: '5',
            },
            {
              a: '1',
              b: '2',
              c: '3',
              d: '4',
              e: '5',
            },
            {
              a: '1',
              b: '2',
              c: '3',
              d: '4',
              e: '5',
            }
          ]
          },
          
          {
            a: '111',
            b: '222',
            c: "33",
            d: '444',
            e: '55',
            f: '666',
            g: '777',
            h: '88',
            i: '999',
            child: [
              {
                a: '1',
                b: '2',
                c: '3',
                d: '4',
                e: '5',
              }
            ]
          },
       ]
       })
   })
  },
}

let splitApi = {
  list(data){
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          a: '111',
          b: '222',
          c: "33",
          d: '444',
          e: '55',
          f: '666',
          g: '777',
          h: '88',
          i: '99',
         },
         {
          a: '111',
          b: '222',
          c: "33",
          d: '444',
          e: '55',
          f: '666',
          g: '777',
          h: '88',
          i: '99',
          },
          
          {
            a: '111',
            b: '222',
            c: "33",
            d: '444',
            e: '55',
            f: '666',
            g: '777',
            h: '88',
            i: '99',

          },
       ]
       })
   })
  },
}


let bomListApi = {
  list(){
    return new Promise((resolve, reject) => {
       
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          Code: '产品编码',
          Name: '产品名称',
          BOMNo: "33",
         },
         {
          Code: '产品编码',
          Name: '产品名称',
          BOMNo: "33",
          },
          
          {
            Code: '产品编码',
            Name: '产品名称',
            BOMNo: "33",
          },
       ]
       })
   })
  },
}

let bomListDialogCombinationApi = {
  list(){
    return new Promise((resolve, reject) => {
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          Name: '产品组合名称1',
          Model: '规格',
          Unit: "单位",
          Quantity: '需求数量',
          Img: '图片',
          Stage: "加工阶段",
          Inventory: "存货类型",
          BomVesion: "",
          child: [
            {
              Code: '子件编码',
              Name: '子件名称',
              Model: '规格',
              Unit: "单位",
              Color: "颜色",
              Quantity: '需求数量',
              Img: '图片',
              Stage: "加工阶段",
              Inventory: "存货类型",
            },
            {
              Code: '子件编码',
              Name: '子件名称',
              Model: '规格',
              Unit: "单位",
              Color: "颜色",
              Quantity: '需求数量',
              Img: '图片',
              Stage: "加工阶段",
              Inventory: "存货类型",
            }
          ]
          
         },
         {
          Name: '产品组合名称2',
          Model: '规格',
          Unit: "单位",
          Quantity: '需求数量',
          Img: '图片',
          Stage: "加工阶段",
          Inventory: "存货类型",
          BomVesion: "",
          child: [
            {
              Code: '子件编码',
              Name: '子件名称',
              Model: '规格',
              Unit: "单位",
              Color: "颜色",
              Quantity: '需求数量',
              Img: '图片',
              Stage: "加工阶段",
              Inventory: "存货类型",
            }
          ]
          },
          
          {
            Name: '产品组合名称3',
            Model: '规格',
            Unit: "单位",
            Quantity: '需求数量',
            Img: '图片',
            Stage: "加工阶段",
            Inventory: "存货类型",
            BomVesion: "",
            child: [
              {
                Code: '子件编码',
                Name: '子件名称',
                Model: '规格',
                Unit: "单位",
                Color: "颜色",
                Quantity: '需求数量',
                Img: '图片',
                Stage: "加工阶段",
                Inventory: "存货类型",
              }
            ]
          },
       ]
       })
   })
  },
}

let bomListDialogAssembleApi = {
  list(){
    return new Promise((resolve, reject) => {
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          Name: '产品名称1',
          Model: '规格',
          Unit: "单位",
          Color: '颜色',
          Quantity: '需求数量',
          Img: '图片',
          Stage: "加工阶段",
          Inventory: "存货类型",
          BomVesion: "",
          child: [
            {
              Code: '子件编码',
              Name: '子件名称',
              Model: '规格',
              Unit: "单位",
              Attr: "属性",
              Color: "颜色",
              Quantity: '需求数量',
              Img: '图片',
              Stage: "加工阶段",
              Inventory: "存货类型",
            },
            {
              Code: '子件编码',
              Name: '子件名称',
              Model: '规格',
              Unit: "单位",
              Attr: "属性",
              Color: "颜色",
              Quantity: '需求数量',
              Img: '图片',
              Stage: "加工阶段",
              Inventory: "存货类型",
            }
          ]
          
         },
         {
          Name: '产品名称2',
          Model: '规格',
          Unit: "单位",
          Color: '颜色',
          Quantity: '需求数量',
          Img: '图片',
          Stage: "加工阶段",
          Inventory: "存货类型",
          BomVesion: "",
          child: [
            {
              Code: '子件编码',
              Name: '子件名称',
              Model: '规格',
              Unit: "单位",
              Attr: "属性",
              Color: "颜色",
              Quantity: '需求数量',
              Img: '图片',
              Stage: "加工阶段",
              Inventory: "存货类型",
            }
          ]
          },
          
          {
            Name: '产品名称3',
            Model: '规格',
            Unit: "单位",
            Color: '颜色',
            Quantity: '需求数量',
            Img: '图片',
            Stage: "加工阶段",
            Inventory: "存货类型",
            BomVesion: "",
            child: [
              {
                Code: '子件编码',
                Name: '子件名称',
                Model: '规格',
                Unit: "单位",
                Attr: "属性",
                Color: "颜色",
                Quantity: '需求数量',
                Img: '图片',
                Stage: "加工阶段",
                Inventory: "存货类型",
              }
            ]
          },
       ]
       })
   })
  },
}

let bomListDialogFittingsApi = {
  list(){
    return new Promise((resolve, reject) => {
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          Code: '配件编码',
          Name: '配件名称1',
          Model: '规格',
          Unit: "单位",
          Quantity: '需求数量',
          Img: '图片',
          remark: "备注",
          Inventory: "存货类型",
          BomVesion: "",
          child: [
            {
              Code: '子件编码',
              Name: '子件名称',
              Model: '规格',
              Unit: "单位",
              Quantity: '需求数量',
              Img: '图片',
              remark: "备注",
              Inventory: "存货类型",
            },
            {
              Code: '子件编码',
              Name: '子件名称',
              Model: '规格',
              Unit: "单位",
              Quantity: '需求数量',
              Img: '图片',
              remark: "备注",
              Inventory: "存货类型",
            }
          ]
          
         },
         {
          Code: '配件编码',
          Name: '配件名称2',
          Model: '规格',
          Unit: "单位",
          Quantity: '需求数量',
          Img: '图片',
          remark: "备注",
          Inventory: "存货类型",
          BomVesion: "",
          child: [
            {
              Code: '子件编码',
              Name: '子件名称',
              Model: '规格',
              Unit: "单位",
              Quantity: '需求数量',
              Img: '图片',
              remark: "备注",
              Inventory: "存货类型",
            }
          ]
          },
          
          {
            Code: '配件编码',
            Name: '配件名称3',
            Model: '规格',
            Unit: "单位",
            Quantity: '需求数量',
            Img: '图片',
            remark: "备注",
            Inventory: "存货类型",
            BomVesion: "",
            child: [
              {
                Code: '子件编码',
                Name: '子件名称',
                Model: '规格',
                Unit: "单位",
                Quantity: '需求数量',
                Img: '图片',
                remark: "备注",
                Inventory: "存货类型",
              }
            ]
          },
       ]
       })
   })
  },
}

let bomListDialogSpecialApi = {
  list(){
    return new Promise((resolve, reject) => {
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          Code: '加工后编码',
          Name: '加工后名称1',
          Model: '规格',
          Attr: '加工后属性',
          Color: '加工后颜色',
          Unit: "单位",
          Quantity: '需求数量',
          Img: '图片',
          remark: "备注",
          child: [
            {
              Code: '加工前编码',
              Name: '加工前名称',
              Model: '规格',
              Attr: '加工前属性',
              Color: '加工前颜色',
              Unit: "单位",
              Quantity: '需求数量',
              Img: '图片',
              remark: "备注",
            },
            {
              Code: '加工前编码',
              Name: '加工前名称',
              Model: '规格',
              Attr: '加工前属性',
              Color: '加工前颜色',
              Unit: "单位",
              Quantity: '需求数量',
              Img: '图片',
              remark: "备注",
            }
          ]
          
         },
         {
          Code: '加工后编码',
          Name: '加工后名称2',
          Model: '规格',
          Attr: '加工后属性',
          Color: '加工后颜色',
          Unit: "单位",
          Quantity: '需求数量',
          Img: '图片',
          remark: "备注",
          child: [
            {
              Code: '加工前编码',
              Name: '加工前名称',
              Model: '规格',
              Attr: '加工前属性',
              Color: '加工前颜色',
              Unit: "单位",
              Quantity: '需求数量',
              Img: '图片',
              remark: "备注",
            }
          ]
          },
          
          {
            Code: '加工后编码',
            Name: '加工后名称3',
            Model: '规格',
            Attr: '加工后属性',
            Color: '加工后颜色',
            Unit: "单位",
            Quantity: '需求数量',
            Img: '图片',
            remark: "备注",
            child: [
              {
                Code: '加工前编码',
                Name: '加工前名称',
                Model: '规格',
                Attr: '加工前属性',
                Color: '加工前颜色',
                Unit: "单位",
                Quantity: '需求数量',
                Img: '图片',
                remark: "备注",
              }
            ]
          },
       ]
       })
   })
  },
}


let bomListDialogGlueApi = {
  list(){
    return new Promise((resolve, reject) => {
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          Code: '模具编码',
          Name: '模具名称1',
          GrossWeight: '每模毛重',
          NetWeight: '每模净重',
          oneOut: '1出几套',
          Quantity: "需求模数",
          Img: '图片',
          remark: "备注",
          BomVesion: '',
          child: [
            {
              Code: '存货编码',
              Name: '存货名称',
              Model: '规格',
              Unit: "单位",
              Color: '加工前颜色',
              Quantity: '需求数量',
              Img: '图片',
              Stage: '加工阶段',
              Inventory: "存货类型",
            },
            {
              Code: '存货编码',
              Name: '存货名称',
              Model: '规格',
              Unit: "单位",
              Color: '加工前颜色',
              Quantity: '需求数量',
              Img: '图片',
              Stage: '加工阶段',
              Inventory: "存货类型",
            }
          ]
          
         },
         {
          Code: '模具编码',
          Name: '模具名称1',
          GrossWeight: '每模毛重',
          NetWeight: '每模净重',
          oneOut: '1出几套',
          Quantity: "需求模数",
          Img: '图片',
          remark: "备注",
          BomVesion: '',
          child: [
            {
              Code: '存货编码',
              Name: '存货名称',
              Model: '规格',
              Unit: "单位",
              Color: '加工前颜色',
              Quantity: '需求数量',
              Img: '图片',
              Stage: '加工阶段',
              Inventory: "存货类型",
            }
          ]
          },
          
          {
            Code: '模具编码',
            Name: '模具名称1',
            GrossWeight: '每模毛重',
            NetWeight: '每模净重',
            oneOut: '1出几套',
            Quantity: "需求模数",
            Img: '图片',
            remark: "备注",
            BomVesion: '',
            child: [
              {
                Code: '存货编码',
                Name: '存货名称',
                Model: '规格',
                Unit: "单位",
                Color: '加工前颜色',
                Quantity: '需求数量',
                Img: '图片',
                Stage: '加工阶段',
                Inventory: "存货类型",
              }
            ]
          },
       ]
       })
   })
  },
}

let notSchedulingApi = {
  list(){
    return new Promise((resolve, reject) => {
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          a: '序号',
          b: '订单号',
          c: '工单号',
          d: '单据日期',
          e: '产品编码',
          f: "产品名称",
          g: '数量',
          h: "部门",
          i: '班组',
          j: '班次',
         },
         {
          a: '序号',
          b: '订单号',
          c: '工单号',
          d: '单据日期',
          e: '产品编码',
          f: "产品名称",
          g: '数量',
          h: "部门",
          i: '班组',
          j: '班次',
          },
          
          {
            a: '序号',
            b: '订单号',
            c: '工单号',
            d: '单据日期',
            e: '产品编码',
            f: "产品名称",
            g: '数量',
            h: "部门",
            i: '班组',
            j: '班次',
          },
       ]
       })
   })
  },
}

let alreadySchedulingApi = {
  list(){
    return new Promise((resolve, reject) => {
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          a: '序号',
          b: '订单号',
          c: '工单号',
          d: '单据日期',
          e: '产品编码',
          f: "产品名称",
          g: '数量',
          h: "部门",
          i: '班组',
          j: '班次',
          k: 0,
          l: '排产开工时间',
         },
         {
          a: '序号',
          b: '订单号',
          c: '工单号',
          d: '单据日期',
          e: '产品编码',
          f: "产品名称",
          g: '数量',
          h: "部门",
          i: '班组',
          j: '班次',
          k: 1,
          l: '排产开工时间',
          },
          
          {
            a: '序号',
            b: '订单号',
            c: '工单号',
            d: '单据日期',
            e: '产品编码',
            f: "产品名称",
            g: '数量',
            h: "部门",
            i: '班组',
            j: '班次',
            k: 3,
          l: '排产开工时间',
          },
       ]
       })
   })
  },
}

let notSchedulingShebeiApi = {
  list(){
    return new Promise((resolve, reject) => {
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          a: '序号',
          b: '订单号',
          c: '工单号',
          d: '单据日期',
          e: '产品编码',
          f: "产品名称",
          g: '数量',
          h: "设备",
          i: '班组',
          j: '班次',
         },
         {
          a: '序号',
          b: '订单号',
          c: '工单号',
          d: '单据日期',
          e: '产品编码',
          f: "产品名称",
          g: '数量',
          h: "设备",
          i: '班组',
          j: '班次',
          },
          
          {
            a: '序号',
            b: '订单号',
            c: '工单号',
            d: '单据日期',
            e: '产品编码',
            f: "产品名称",
            g: '数量',
            h: "设备",
            i: '班组',
            j: '班次',
          },
       ]
       })
   })
  },
}

let alreadySchedulingShebeiApi = {
  list(){
    return new Promise((resolve, reject) => {
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          a: '序号',
          b: '订单号',
          c: '工单号',
          d: '单据日期',
          e: '产品编码',
          f: "产品名称",
          g: '数量',
          h: "设备",
          i: '班组',
          j: '班次',
          k: 0,
          l: '排产开工时间',
         },
         {
          a: '序号',
          b: '订单号',
          c: '工单号',
          d: '单据日期',
          e: '产品编码',
          f: "产品名称",
          g: '数量',
          h: "设备",
          i: '班组',
          j: '班次',
          k: 1,
          l: '排产开工时间',
          },
          
          {
            a: '序号',
            b: '订单号',
            c: '工单号',
            d: '单据日期',
            e: '产品编码',
            f: "产品名称",
            g: '数量',
            h: "设备",
            i: '班组',
            j: '班次',
            k: 3,
          l: '排产开工时间',
          },
       ]
       })
   })
  },
}

let historicalschedulingApi = {
  list(){
    return new Promise((resolve, reject) => {
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          a: '1',
          b: '2022-1-2',
         },
         {
          a: '2',
          b: '2022-1-4',
          },
          
          {
            a: '3',
            b: '2022-1-5',
          },
       ]
       })
   })
  },
  info(type){
    console.log('info type', type)
    if(type === 1){
      console.log('info')
      return new Promise((resolve, reject) => {
        resolve({
         Code: 0,
         Count: 3,
         Data: {
          notData: [
            {
              a: '序号',
              b: '订单号',
              c: '工单号',
              d: '单据日期',
              e: '产品编码',
              f: '产品名称',
              g: '部门',
              h: '班组',
              i: '班次',
            },
            {
              a: '序号',
              b: '订单号',
              c: '工单号',
              d: '单据日期',
              e: '产品编码',
              f: '产品名称',
              g: '部门',
              h: '班组',
              i: '班次',
            },
            {
              a: '序号',
              b: '订单号',
              c: '工单号',
              d: '单据日期',
              e: '产品编码',
              f: '产品名称',
              g: '部门',
              h: '班组',
              i: '班次',
            }
           ],
           alreadyData: [
            {
              a: '序号',
              b: '订单号',
              c: '工单号',
              d: '单据日期',
              e: '产品编码',
              f: '产品名称',
              g: '部门',
              h: '班组',
              i: '班次',
              j: '完工状态',
              k: '排产开工时间'
            },
            {
              a: '序号',
              b: '订单号',
              c: '工单号',
              d: '单据日期',
              e: '产品编码',
              f: '产品名称',
              g: '部门',
              h: '班组',
              i: '班次',
              j: '完工状态',
              k: '排产开工时间'
            },
            {
              a: '序号',
              b: '订单号',
              c: '工单号',
              d: '单据日期',
              e: '产品编码',
              f: '产品名称',
              g: '部门',
              h: '班组',
              i: '班次',
              j: '完工状态',
              k: '排产开工时间'
            }
           ]
         }
       })
      })
    }

    if(type === 2){
      return new Promise((resolve, reject) => {
        resolve({
         Code: 0,
         Count: 3,
         Data: {
          notData: [
            {
              a: '序号',
              b: '订单号',
              c: '工单号',
              d: '单据日期',
              e: '产品编码',
              f: '产品名称',
              g: '设备',
              h: '班组',
              i: '班次',
            },
            {
              a: '序号',
              b: '订单号',
              c: '工单号',
              d: '单据日期',
              e: '产品编码',
              f: '产品名称',
              g: '设备',
              h: '班组',
              i: '班次',
            },
            {
              a: '序号',
              b: '订单号',
              c: '工单号',
              d: '单据日期',
              e: '产品编码',
              f: '产品名称',
              g: '设备',
              h: '班组',
              i: '班次',
            }
           ],
           alreadyData: [
            {
              a: '序号',
              b: '订单号',
              c: '工单号',
              d: '单据日期',
              e: '产品编码',
              f: '产品名称',
              g: '设备',
              h: '班组',
              i: '班次',
              j: '完工状态',
              k: '排产开工时间'
            },
            {
              a: '序号',
              b: '订单号',
              c: '工单号',
              d: '单据日期',
              e: '产品编码',
              f: '产品名称',
              g: '设备',
              h: '班组',
              i: '班次',
              j: '完工状态',
              k: '排产开工时间'
            },
            {
              a: '序号',
              b: '订单号',
              c: '工单号',
              d: '单据日期',
              e: '产品编码',
              f: '产品名称',
              g: '设备',
              h: '班组',
              i: '班次',
              j: '完工状态',
              k: '排产开工时间'
            }
           ]
         }
       })
      })
    }
   
  },
}


let baseData = {
  list(){
    return new Promise((resolve, reject) => {
        resolve({
         Code: 0,
         Count: 3,
         Data: [
         {
          warehouse: '仓库1',
          DocNo: '2',
          DocTime: '50',
         },
         {
          warehouse: '仓库1',
          DocNo: '52',
          DocTime: '520',
          },
          {
            warehouse: '仓库1',
            DocNo: '41',
            DocTime: '845',
          },
          {
            warehouse: '仓库1',
            DocNo: '12',
            DocTime: '12321',
          },
          {
            warehouse: '仓库2',
            DocNo: '01',
            DocTime: '745',
           },
           {
            warehouse: '仓库2',
            DocNo: '012',
            DocTime: '845',
            },
            {
              warehouse: '仓库2',
              DocNo: '03',
              DocTime: '184',
            },
            {
              warehouse: '仓库3',
              DocNo: '03',
              DocTime: '784',
            },
       ]
       })
   })
  },
}


  export {
    pceApi,
    pcsApi,
    pcdApi,
    ptdApi,
    ptsApi,
    ptpApi,
    ptmdApi,
    ptmsApi,
    ptmeApi,
    pcpApi,
    pcaApi,
    pcp1Api,
    mouldListApi,
    MOuldList,
    getProcess,
    fittingListApi,
    fittingList,
    puList,
    puListApi,
    historicalclothApi,
    pcd1Api,
    jiagongdanApi,
    pcddApi,
    clothDialogApi,
    clothDialog1Api,
    clothDialog12Api,
    clothDialog3Api,
    mergeApi,
    mergeDialogApi,
    splitApi,
    bomListApi,
    bomListDialogCombinationApi,
    bomListDialogAssembleApi,
    bomListDialogFittingsApi,
    bomListDialogSpecialApi,
    bomListDialogGlueApi,
    notSchedulingApi,
    alreadySchedulingApi,
    notSchedulingShebeiApi,
    alreadySchedulingShebeiApi,
    historicalschedulingApi,
    baseData
  }